import PROFILE from "./profile.ms";
import ACCOUNT from "./account.ms";

export default {
  ...PROFILE,
  ...ACCOUNT,
};
